import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import User from '../../models/user';
import { AuthService } from '../../services/auth-service';
import { BackButtonComponent } from '../back-button-component/back-button-component';
import { LoadingComponent } from '../loading-component/loading-component';
import { UserService } from '../../services/user-service';

@Component({
  selector: 'app-login-component',
  imports: [CommonModule, FormsModule, RouterModule, BackButtonComponent, LoadingComponent],
  templateUrl: './login-component.html',
  styleUrl: './login-component.css',
})
export class LoginComponent {
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  username = '';
  password = '';
  errorMessage = '';
  isSubmitting = false;

  login(): void {
    if (!this.username.trim() || !this.password) {
      this.errorMessage = 'Username and password are required.';
      return;
    }

    this.errorMessage = '';
    this.isSubmitting = true;

    this.userService.getUsers().subscribe({
      next: (users: User[]) => {
        const matchedUser = users.find((user) =>
          user.username === this.username.trim() && user.password === this.password
        );

        this.isSubmitting = false;

        if (!matchedUser) {
          this.errorMessage = 'Invalid username or password.';
          return;
        }

        this.authService.login(new User(matchedUser));
        this.router.navigate(['/home']);
      },
      error: () => {
        this.isSubmitting = false;
        this.errorMessage = 'Could not reach the login service.';
      },
    });
  }
}
